import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.overview.dashboard');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-overview-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.overview.dashboard/view.scss */
/* src/app/portal.overview.dashboard/view.scss: no such file or directory */`],
})
export class PortalOverviewDashboardComponent implements OnInit {
    @Input() data!: ResearcherData;
    @Input() period: any;
    @Input() years: number[] = [];

    constructor(@Inject( Service)         public service: Service,    ) { }


    public async ngOnInit() {
    }

    public onYearsChange(years: number[]) {
        this.years = years ?? [];

        if (this.years.length > 0) {

            this.period = {
                start: this.years[0],
                end: this.years[this.years.length - 1]
            };
        } else {
            this.period = { start: null, end: null };
        }
        this.service.render();
    }
}

export default PortalOverviewDashboardComponent;